import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import PartnerAccessFrequencyGauge from './PartnerAccessFrequencyGauge';
import CustomerSuccessHistoryService from '../../services/CustomerSuccessHistoryService';
import { PartnerAccessFrequencyListService } from '../../services/CustomerSuccessKpiListService';

class PartnerAccessFrequencyGaugeContainer extends React.Component {
  constructor(props) {
    super(props);
    PartnerAccessFrequencyListService.load();
  }

  render() {
    return (
      <PartnerAccessFrequencyGauge
        loading={
          PartnerAccessFrequencyListService.fetchCurrent.fetching ||
          PartnerAccessFrequencyListService.fetchPrevious.fetching
        }
        currentValue={toJS(PartnerAccessFrequencyListService.global.current)}
        previousValue={toJS(PartnerAccessFrequencyListService.global.previous)}
        onClickHistory={() => CustomerSuccessHistoryService.openDialog('PARTNER_ACCESS_FREQUENCY')}
        formatter={PartnerAccessFrequencyListService.getFormattedValue}
      />
    );
  }
}

export default observer(PartnerAccessFrequencyGaugeContainer);
